<ng-container *ngIf="_.envIsZelis">
  <div class="zelis-container">
    <div class="logos">
      <zelis-logo [size]="39"></zelis-logo>
      <riv-icon [name]="'Plus'" [size]="24" [strokeWidth]="2"></riv-icon>
      <logo [size]="39"></logo>
    </div>
    <div class="body">
      <div class="title">Log into your Zelis account</div>
      <a
        rivButton
        [size]="'large'"
        [variant]="'primary'"
        href="https://provider.zelispayments.com/"
      >
        Go to Zelis
      </a>
      <p class="explanation">
        In order to access Rivet, you will need to log into your existing Zelis
        account. To return to this page, click on the claims insights link from
        the payments navigation dropdown.
      </p>
      <a class="employee-link" (click)="_.setEnvIsZelis(false)">
        If you are a Zelis employee, click here to log in
      </a>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!_.envIsZelis">
  <div class="rv-center my-medium"><logo></logo></div>
  <div *ngIf="_.accounts?.length > 0" class="rv-rows large">
    <p class="rv-center">Please select an account</p>
    <div>
      <button
        *ngFor="let account of _.accounts"
        rivButton
        [variant]="'basic'"
        [size]="'large'"
        [full]="true"
        type="button"
        (click)="_.setAccountId(account.id)"
      >
        {{ account.name }}
      </button>
    </div>
  </div>
  <div *ngIf="!(_.accounts?.length > 0)" class="rv-rows large">
    <form class="rv-grid large" (ngSubmit)="_.validateAndSubmit()">
      <div class="rv-rows large">
        <div>
          <riv-text-field
            autocomplete="email"
            name="email"
            label="Email"
            placeholder="Enter your email"
            type="email"
            [value]="_.email"
            (valueChange)="_.setEmail($event); _.clearAllErrors()"
            size="large"
            [state]="_.emailHasIssue ? 'error' : 'valid'"
          ></riv-text-field>
        </div>
        <div class="rv-rows small">
          <riv-text-field
            autocomplete="password"
            name="password"
            label="Password"
            placeholder="Enter your password"
            [type]="_.showPassword ? 'text' : 'password'"
            [value]="_.password"
            (valueChange)="_.setPassword($event); _.clearAllErrors()"
            size="large"
            [state]="_.passwordHasIssue ? 'error' : 'valid'"
          ></riv-text-field>
          <div class="rv-flex rv-body-small">
            <riv-checkbox
              identifier="show-password"
              [value]="_.showPassword"
              (valueChange)="_.setShowPassword($event)"
            >
              Show password
            </riv-checkbox>
            <a
              class="rv-link"
              routerLink="/login/forgot"
              [queryParams]="{ email: _.email }"
              >Forgot password?</a
            >
          </div>
        </div>
        <submit-error *ngIf="_.clientSideError">
          {{ _.clientSideError }}
        </submit-error>
        <submit-error *ngIf="_.submitLoad.error?.error">
          {{ _.submitLoad.error.error.message }}
        </submit-error>
        <button
          rivButton
          [variant]="'primary'"
          [size]="'xlarge'"
          [full]="true"
          [disabled]="_.submitLoad.loading"
          type="submit"
        >
          <ng-container *ngIf="_.submitLoad.loading; else submit">
            Logging in...
          </ng-container>
          <ng-template #submit> Log in </ng-template>
        </button>
      </div>
    </form>
    <div class="rv-body-small rv-low-contrast rv-flex">
      <div class="rv-flex-grow-auto divider-rule"></div>
      <div class="mx-small">or</div>
      <div class="rv-flex-grow-auto divider-rule"></div>
    </div>
    <a
      rivButton
      [variant]="'basic'"
      [size]="'xlarge'"
      [full]="true"
      routerLink="/login/sso"
      [queryParams]="{ email: _.email, next: _.next }"
    >
      Log in with single sign-on
    </a>
  </div>
  <div class="rv-explanation my-small rv-center">
    Need help? <a class="rv-link" (click)="openIntercom()">Contact support.</a>
  </div>
</ng-container>
